export default __webpack_public_path__ + "static/media/No.5-4.d43add47.jpg";